// Sites & locations tab (BUILD_SPEC.md §5.1, §5.2) — combined per plan.md G26's
// scope ("Sites & locations: CRUD sites; CRUD locations ... but NOT silo
// calibration, that's G22"). Two independent registers stacked on one screen.
import { Divider, Stack } from '@mantine/core';
import { PageHeader } from '../../../components/PageHeader';
import { LocationRegister } from './LocationRegister';
import { SiteRegister } from './SiteRegister';

export function SitesLocationsPanel() {
  return (
    <Stack gap="xl">
      <PageHeader
        title="Sites & locations"
        description="Set up your physical sites, and the silos, warehouses and yards within each one — a site is a plant; locations are the places inside it."
      />
      <SiteRegister />
      <Divider />
      <LocationRegister />
    </Stack>
  );
}
